module.exports = __webpack_public_path__ + "static/img/active3.ebeebda6.png";